var _g, _path, _g2, _path2, _g3, _g4, _path3, _g5, _circle, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultLeft = function SvgDefaultLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 199,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#default-left_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#default-left_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF63FD",
    d: "M175.53 1c12.962 0 23.469 10.522 23.47 23.5S188.492 48 175.53 48h-.001v-7.874C171.23 44.956 164.97 48 158 48V1c6.97 0 13.23 3.044 17.529 7.876V1z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#default-left_svg__c)",
    d: "M175.53 1c12.962 0 23.469 10.522 23.47 23.5S188.492 48 175.53 48h-.001v-7.874A24 24 0 0 1 173 42.572V6.428c.902.752 1.748 1.57 2.529 2.448V1z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M137 0h4v48h-4z",
    opacity: 0.9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#default-left_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120 0h13v48h-13z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF73FD",
    d: "M120 0H70v48h50z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#default-left_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#default-left_svg__f)",
    fillOpacity: 0.99,
    d: "M0 0h50v48H0z",
    transform: "matrix(-1 0 0 1 120 0)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#default-left_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M68 0h2v48h-2z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF73FD",
    d: "M68 0H0v48h68z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#default-left_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#default-left_svg__i)",
    d: "M0 0h48v68H0z",
    transform: "matrix(0 1 1 0 0 0)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 24,
    r: 24,
    fill: "#FF4B5A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6263",
    d: "M32 0c13.255 0 24 10.745 24 24S45.255 48 32 48q-.502-.001-1-.023V.021q.498-.02 1-.021"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "default-left_svg__a",
    width: 41,
    height: 47,
    x: 158,
    y: 1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "1.4285714626312256 1.4285714626312256",
    numOctaves: 3,
    result: "noise",
    seed: 9496,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "noise",
    result: "alphaNoise",
    type: "luminanceToAlpha"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    "in": "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    type: "discrete"
  })), /*#__PURE__*/React.createElement("feComposite", {
    "in": "coloredNoise1",
    in2: "shape",
    operator: "in",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.24)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "color1Flood",
    in2: "noise1Clipped",
    operator: "in",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_7455_21381"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "default-left_svg__b",
    width: 41,
    height: 47,
    x: 158,
    y: 1,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "2 2",
    numOctaves: 3,
    result: "noise",
    seed: 7452,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "noise",
    result: "alphaNoise",
    type: "luminanceToAlpha"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    "in": "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    type: "discrete"
  })), /*#__PURE__*/React.createElement("feComposite", {
    "in": "coloredNoise1",
    in2: "shape",
    operator: "in",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.06)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "color1Flood",
    in2: "noise1Clipped",
    operator: "in",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_7455_21381"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "default-left_svg__d",
    width: 15,
    height: 52,
    x: 118,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.498039 0 0 0 0 0.992157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_7455_21381"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "1.25 1.25",
    numOctaves: 3,
    result: "noise",
    seed: 1831,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "noise",
    result: "alphaNoise",
    type: "luminanceToAlpha"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    "in": "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    type: "discrete"
  })), /*#__PURE__*/React.createElement("feComposite", {
    "in": "coloredNoise1",
    in2: "effect1_innerShadow_7455_21381",
    operator: "in",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 132, 253, 0.46)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "color1Flood",
    in2: "noise1Clipped",
    operator: "in",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_7455_21381"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "effect1_innerShadow_7455_21381"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "default-left_svg__e",
    width: 50,
    height: 48,
    x: 70,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "1.25 1.25",
    numOctaves: 3,
    result: "noise",
    seed: 9339,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "noise",
    result: "alphaNoise",
    type: "luminanceToAlpha"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    "in": "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    type: "discrete"
  })), /*#__PURE__*/React.createElement("feComposite", {
    "in": "coloredNoise1",
    in2: "shape",
    operator: "in",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 108, 253, 0.8)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "color1Flood",
    in2: "noise1Clipped",
    operator: "in",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_7455_21381"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "default-left_svg__g",
    width: 2,
    height: 48,
    x: 68,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "2 2",
    numOctaves: 3,
    result: "noise",
    seed: 1831,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "noise",
    result: "alphaNoise",
    type: "luminanceToAlpha"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    "in": "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    type: "discrete"
  })), /*#__PURE__*/React.createElement("feComposite", {
    "in": "coloredNoise1",
    in2: "shape",
    operator: "in",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 132, 253, 0.3)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "color1Flood",
    in2: "noise1Clipped",
    operator: "in",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_7455_21381"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "default-left_svg__h",
    width: 68,
    height: 48,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "1.25 1.25",
    numOctaves: 3,
    result: "noise",
    seed: 9339,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "noise",
    result: "alphaNoise",
    type: "luminanceToAlpha"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    "in": "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    type: "discrete"
  })), /*#__PURE__*/React.createElement("feComposite", {
    "in": "coloredNoise1",
    in2: "shape",
    operator: "in",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 108, 253, 0.43)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "color1Flood",
    in2: "noise1Clipped",
    operator: "in",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_7455_21381"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-left_svg__c",
    x1: 199,
    x2: 173,
    y1: 24.5,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF62E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8151E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-left_svg__f",
    x1: 50,
    x2: 0,
    y1: 0,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF73FD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "default-left_svg__i",
    x1: 48,
    x2: -15.326,
    y1: 0,
    y2: 38.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF73FD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgDefaultLeft;